<ng-container *ngIf="name && (imageUrl$ | async) as imageUrl; else defaultImage">
  <img [src]="imageUrl" alt="Doctors4UA" />
</ng-container>

<ng-template #defaultImage>
  <img [src]="'/assets/images/' + default" alt="Doctors4UA" />
</ng-template>
